export default __webpack_public_path__ + "static/How AI is Transforming LL_02-b3010b82d8302485676ae2bf46a2bedc.jpg";